
interface ButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  variant?: 'primary' | 'secondary' | 'outline';
  type?: 'button' | 'submit';
  className?: string;
  disabled?: boolean;
}

export default function Button({ 
  children, 
  onClick, 
  variant = 'primary', 
  type = 'button',
  className = '',
  disabled = false 
}: ButtonProps) {
  const baseClasses = "px-6 py-3 rounded-lg font-medium transition-colors cursor-pointer whitespace-nowrap";
  
  const variantClasses = {
    primary: "bg-indigo-600 hover:bg-indigo-700 text-white shadow-md",
    secondary: "bg-cyan-400 hover:bg-cyan-500 text-white shadow-md", 
    outline: "border-2 border-indigo-600 text-indigo-600 hover:bg-indigo-600 hover:text-white"
  };

  return (
    <button
      type={type}
      onClick={onClick}
      // className={`${baseClasses} ${variantClasses[variant]} ${className}`}
      disabled={disabled}
      className={`${baseClasses} ${variantClasses[variant]} ${disabled ? 'opacity-50 cursor-not-alStandarded' : ''} ${className}`}
    >
      {children}
    </button>
  );
}
